const instances = {
    "NDCS_MAKE": {
        name: "NDCS_MAKE",
        domain:'dainsta.com'
    },
    '8XPARTS_MAKE': {
        name: '8XPARTS_MAKE',
        domain:'8xparts.com'
    },
    "PIPL_MAKE":{
        name:'PIPL_MAKE',
        domain:'precilayer.com',
    }
};

const name = process.env.REACT_APP_INSTANCE_NAME || "NDCS_MAKE";

export const allInstanceData = {
    '_8xPart': '8XPARTS_MAKE',
    'NDCS': "NDCS_MAKE",
    'PIPL':'PIPL_MAKE',
};

export const currentInstance = instances[name];